import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type { CommendaAiMutationResult } from '../types';
import type { IDocumentReaderUploadBatchResponse } from './types';

/** One batch of an upload with the parts S3 already holds, read on demand to resume or retry. Not an
 * SWR read: it runs from a user action and its answer changes with every stored part. */
export async function getDocumentReaderUploadBatch(
  uploadId: string,
  batchIndex: number,
  signal?: AbortSignal
): Promise<CommendaAiMutationResult<IDocumentReaderUploadBatchResponse>> {
  return AgentApiRequestHelper.mutate<IDocumentReaderUploadBatchResponse>(
    `agent-platform/document-reader/uploads/${encodeURIComponent(uploadId)}?batch=${batchIndex}`,
    { method: 'GET', ...(signal ? { signal } : {}) },
    'Could not read the data room upload.'
  );
}
